<template>
    <span>
        <i class="fa fa-edit pointer text-warning" @click="$refs.editMemberModal.open()"></i>

        <!-- Delete member modal -->
        <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_EDIT_MODAL_TITLE')" ref="editMemberModal" class="text-left">
            <div class="form-group">
                <label for="name">{{ $t('UI_INSTANCE_MEMBER_GROUP_MEMBER_NAME') }}</label>
                <input type="text" id="name" v-model="memberName" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_NAME')" class="form-control" v-on:keyup.enter="editMember">
            </div>

            <div class="form-group">
                <label for="description">{{ $t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DESCRIPTION') }}</label>
                <input type="text" id="description" v-model="memberDescription" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DESCRIPTION')" class="form-control" v-on:keyup.enter="editMember">
            </div>


            <div slot="button">
                <button class="btn btn-primary" @click="editMember">
                    {{ $t("UI_MODAL_BUTTON_SAVE") }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.editMemberModal.close()">
                    {{ $t("UI_MODAL_BUTTON_CLOSE") }}
                </button>
            </div>
        </sweet-modal>
    </span>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

const InstanceMemberRepository = RepositoryFactory.get('instanceMembers');

export default {
  name: 'InstanceMemberEdit',
  props: ['member', 'group'],
  components: { SweetModal },
  data() {
    return {
      memberName: '',
      memberDescription: '',
    };
  },
  mounted() {
    this.memberName = this.member.name;
    this.memberDescription = this.member.description;
  },
  methods: {
    editMember() {
      InstanceMemberRepository.editMember(this.group.id, this.member.id, this.memberName, this.memberDescription).then(() => {
        this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_EDITED', { member: this.member.name }));
        InstanceMemberRepository.refetchMemberList();
        this.$refs.editMemberModal.close();
      });
    },
  },
};
</script>

<style scoped>

</style>
